import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_CLIENT_API() + 'auth/firmy/';

export default {

    getFirmy() {
        return axios({
            method: 'get',
            url: URL,
        });
    },

    getFirma(id) {
        return axios({
            method: 'get',
            url: URL+id,
        });
    },

    addFirma(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editFirma(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteFirma(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    szukajFirmePoNipie(nip) {
        return axios({
                url: 'https://gw1.topsa.com.pl/gus/api/regon/json/daneSzukajByNip/' + nip,
                method: 'get',
            }
        )
    },

    szukajFirmePoNipieAlboPoNazwie(string) {
        return axios({
                url: URL + 'search?nazwaOrNip=' + string,
                method: 'get',
            }
        )
    },
}


// WEBPACK FOOTER //
// ./src/modules/klienciConfig/firmy/FirmyService.js